import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { applyThemeMode, ThemeMode } from '../theme';
import { getSecureItem, setSecureItem } from '../storage';

const THEME_STORAGE_KEY = 'themeMode';

interface ThemeContextValue {
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
}

const ThemeContext = createContext<ThemeContextValue>({ mode: 'light', setMode: () => {} });

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [mode, setModeState] = useState<ThemeMode>('light');

  useEffect(() => {
    getSecureItem(THEME_STORAGE_KEY).then((saved) => {
      if (saved === 'dark' || saved === 'light' || saved === 'mocha') {
        applyThemeMode(saved);
        setModeState(saved);
      }
    });
  }, []);

  const setMode = (next: ThemeMode) => {
    // Mutate the shared colors/gradients objects BEFORE the state update
    // that triggers a remount, so the very first render under the new key
    // already reads the new palette.
    applyThemeMode(next);
    setModeState(next);
    setSecureItem(THEME_STORAGE_KEY, next);
  };

  return <ThemeContext.Provider value={{ mode, setMode }}>{children}</ThemeContext.Provider>;
}

export function useThemeMode() {
  return useContext(ThemeContext);
}
